import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {requestGetJobList} from "@app/services/JobService";
import Select from "react-select";

const SelectJobModal = (props) => {
    const [selectJob, setSelectJob] = useState({});
    const [selectJobOptions, setSelectJobOptions] = useState([]);

    const {isShow, onConfirm, onClose} = props

    const fetchJobList = async () => {
        const res = await requestGetJobList({unlimited: true});
        const jobOptionList = res.content.jobs.map((item) => {
            return  {value: item.id, label : item.job_name}
        });
        setSelectJobOptions(jobOptionList);
    }

    const onSelectJob = (jobOption) => {
        setSelectJob(jobOption)
    }

    useEffect(() => {
        fetchJobList().then()
    },[]);

    return (
        <>
            <Modal show={isShow}
                   size={"lg"}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {'Chọn Job'}
                    </Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className={"row"}>
                        <div className='col-sm-6'>
                            <div className='form-group'>
                                <label className={'w-100'}>Chọn job</label>
                                <Select options={selectJobOptions}
                                        placeholder={"Chọn job"}
                                        value={selectJob}
                                        onChange={values => {
                                            onSelectJob(values);
                                        }}
                                />
                            </div>
                        </div>
                        <div className={'mt-4'}>
                            <button
                                type='button'
                                className='btn btn-primary mt-2'
                                onClick={() => onConfirm(selectJob.value)}
                                disabled={!selectJob.value}
                            >
                                {"Chọn job"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SelectJobModal;
